// Lib
import { createAction } from '@reduxjs/toolkit';

export const OpenModal = createAction('OPEN_MODAL');
export const ChangeModalProps = createAction('CHANGE_MODAL_PROPS');
export const CloseModal = createAction('CLOSE_MODAL');
